var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyaccountHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004FFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_profile_1074726",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    className: "st0",
    d: "M15,1C7.2680135,1,1,7.2680135,1,15s6.2680135,14,14,14s14-6.268013,14-14S22.731987,1,15,1z  M8.7705183,25.1505184C8.9336033,21.7737522,11.624238,19.06744,15,18.8847408 c3.3760014,0.1816711,6.0673428,2.8877964,6.2305183,6.2647419c-3.8256111,2.3333588-8.6343889,2.3333588-12.460001,0 L8.7705183,25.1505184z M15,15.5247412c-1.5069065-0.0022869-2.7277689-1.223609-2.7294817-2.7305174 c0.0039406-1.4931288,1.217555-2.7003517,2.710681-2.6964121C14.9874659,10.0978279,14.9937334,10.097867,15,10.0979271 c1.5065041,0.002284,2.7271976,1.2229776,2.7294807,2.7294807c-0.0033684,1.4931288-1.2165165,2.700819-2.7096453,2.6974497 C15.0132227,15.5248442,15.0066109,15.5248041,15,15.5247412z M23.1552601,23.6800003 c-0.6560116-3.1037655-2.9281235-5.6162357-5.9505196-6.579998c2.364336-1.2233801,3.2892666-4.1317987,2.0658875-6.4961348 s-4.1317968-3.2892661-6.4961348-2.0658875c-1.6035461,0.8297215-2.608943,2.4860163-2.6050129,4.291503 c-0.0010939,1.8047647,1.0140314,3.456398,2.6247406,4.2705193c-3.0286083,0.9537849-5.3045592,3.4709377-5.9494805,6.579998 c-4.78617-4.5040245-5.014894-12.0352154-0.5108685-16.8213844s12.0352173-5.014894,16.8213863-0.5108685 s5.0148907,12.0352173,0.51087,16.8213882C23.5010452,23.344553,23.330677,23.5149212,23.1552601,23.6800003z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyaccountHeader);
export default __webpack_public_path__ + "static/media/icon_myaccount_header.4dd13be2dce46c3c30d26ecc4a5fdf8c.svg";
export { ForwardRef as ReactComponent };